var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 40C31.4934 40 40 31.4934 40 21C40 10.5066 31.4934 2 21 2C10.5066 2 2 10.5066 2 21C2 31.4934 10.5066 40 21 40Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.0003H30.5C30.4996 23.1982 29.7371 25.3279 28.3425 27.0266C26.9479 28.7253 25.0074 29.8879 22.8518 30.3163C20.6961 30.7447 18.4585 30.4124 16.5203 29.3761C14.5822 28.3397 13.0633 26.6633 12.2226 24.6326C11.3818 22.602 11.2712 20.3426 11.9095 18.2395C12.5478 16.1363 13.8956 14.3196 15.7232 13.0988C17.5509 11.878 19.7452 11.3287 21.9325 11.5444C24.1197 11.7602 26.1645 12.7276 27.7184 14.2819",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/G.b57c567cd19100c151481e51ef857cbb.svg";
export { ForwardRef as ReactComponent };